const getPages = (name, path = "views") => {
  return () => {
    return import(`@/${path}/${name}.vue`);
  }
};

const tpagedefault = (body, header = getPages("header", "components"), footer = getPages("footer",
  "components")) => {
  return {
    header: header,
    body: body,
    footer: footer
  };
};

export const getPage = getPages;
export const pagedefault = tpagedefault;
export default {
  getPages,
  tpagedefault
}

